define('meetings/meeting-history/meeting-history',['require','exports','module','knockout','plugins/router','react-meeting-history','api-access','api-access','api-access','lodash','moment','i18next','tagmanager','meetings/lib/telemetry-client/telemetry-service','plugins/dialog','meetings/lib/past-meeting-report/past-meeting-report','lib/multivariate-testing/multivariate-testing','web-urls','lib/binders/datepicker','jquery-ui-helper'],function (require, exports, module) {
    var ko = require('knockout');
    var router = require('plugins/router');
    var MeetingHistory = require('react-meeting-history');

    var meetingsApi = require('api-access').meetings;
    var recordingsApi = require('api-access').recordings;
    var userApi = require('api-access').user;
    var _ = require('lodash');
    var moment = require('moment');
    var i18n = require('i18next');
    var tagmanager = require('tagmanager');
    var telemetrySvc = require('meetings/lib/telemetry-client/telemetry-service');
    var dialog = require('plugins/dialog');
    var PastMeetingReport = require('meetings/lib/past-meeting-report/past-meeting-report');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');
    var webUrls = require('web-urls');

    require('lib/binders/datepicker');
    require('jquery-ui-helper').setDatepickerLocale(i18n.lng());

    module.exports = function () {
        var self = this;

        // Public Variables
        self.router = router; // Router is used to construct .meeting-nav
        self.visibleMeetings = ko.observableArray();
        self.useAmPm = ko.observable(i18n.t('web-technical.useAmPm'));

        self.moreMeetingsToShow = ko.observable(false);
        self.nextMeetingBatch = ko.observable();
        self.hasMeetingsHistory = false;  // To track if there is any meeting history. If not, hide the date picker.
        self.me = ko.observable({});
        self.userSettings = ko.observable({});

        self.fromDate = ko.observable();
        self.toDate = ko.observable();
        self.g2mmSchedulingTest = ko.observable();
        self.meetingFrontendSvcUrl = webUrls.get('baseUrl');
        self.transcriptsUrl = webUrls.get('transcriptsUrl');
        self.meetingDiagnosticsBaseUrl = webUrls.get('meetingDiagnosticsBaseUrl') + '#/sessions/';

        self.showLoadingIndicator = ko.observable(false);

        var initDatepicker = function (input, inst, obj) {
            var top = obj.offset().top;
            var left = obj.offset().left;
            var dpWidth = inst.dpDiv.outerWidth();
            setTimeout(function () {
                if (window.innerWidth >= left + dpWidth) {
                    inst.dpDiv.css({
                        top: top + input.offsetHeight,
                        left: left
                    });
                } else {
                    inst.dpDiv.css({
                        top: top + input.offsetHeight,
                        left: window.innerWidth - dpWidth
                    });
                }
            }, 0);
        };

        self.fromDateOptions = {
            minDate: moment().subtract(1, 'y').toDate(),
            maxDate: moment().toDate(),
            beforeShow: function (input, inst) {
                initDatepicker(input, inst, $(this));
            }
        };

        self.toDateOptions = {
            minDate: moment().subtract(1, 'y').toDate(),
            maxDate: moment().toDate(),
            beforeShow: function (input, inst) {
                initDatepicker(input, inst, $(this));
            }
        };

        // Private Variables

        var NUMBER_OF_MEETINGS_TO_RETURN = 10;
        var nextMeetingPageNumber = 0;

        var viewReport = function (meetingData) {
            tagmanager.gaEvent({
                category: 'Meeting History',
                action: 'View Attendee Report'
            });

            dialog.show(new PastMeetingReport(meetingData.subject, meetingData.attendees, meetingData.sessionId));
        };

        var onCloudRecordingAction = function (action, recording, meetingId) {
            var sessionTrackingId = telemetrySvc.getSessionTracking('mfe');
            tagmanager.gaEvent({
                category: 'Meeting History',
                action: action + ' Cloud Recording'
            });
            telemetrySvc.report({
                ev_name: 'featureUse',
                sa_type: 'record',
                sa_state: action,
                sa_destination: 'cloud',
                sa_source: recording.recordingId,
                ga_meetingId: meetingId,
                ga_id_sessiontracking: sessionTrackingId
            });
        };

        /*
         * Click listener wrapper for "show more" meetings link
         */
        var showMoreMeetingsLinkClick = function () {
            tagmanager.gaEvent({
                category: 'Meeting History',
                action: 'Show More Link'
            });
            // self.currentMeetingBatch.push(self.nextMeetingBatch());
            return self.showMoreMeetings();
        };

        var onDeleteRecordingClick = function (sessionId) {
            return recordingsApi.deleteRecording(sessionId);
        };

        var shareTypes = {
            PUBLIC: 'PUBLIC',
            PRIVATE: 'PRIVATE'
        };

        var createShareScope = function (isPublic) {
            return [{type: isPublic ? shareTypes.PUBLIC : shareTypes.PRIVATE}];
        };

        var getShareLink = function (shareKey) {
            return self.transcriptsUrl + '/#/s/' + shareKey;
        };

        var isScopePublic = function (scope) {
            return scope.some(function (obj) {
                return obj.type === shareTypes.PUBLIC;
            });
        };

        var parseShareResponse = function (resp) {
            var shareResp = {};
            shareResp.link = getShareLink(resp.shareKey);
            shareResp.isPublic = isScopePublic(resp.scope);
            return shareResp;
        };

        var createSharedLink = function (session, isPublic) {
            return recordingsApi.createShare(session.sessionId, self.me().accountKey, self.me().key, createShareScope(isPublic))
                .then(function (resp) {
                    return parseShareResponse(resp);
                });
        };

        var fetchSharedLink = function (session) {
            if (session.recording) {
                return recordingsApi.getShareFromSession(session.sessionId, self.me().accountKey, self.me().key)
                    .then(function (resp) {
                        return parseShareResponse(resp);
                    }, function () {
                        return createSharedLink(session, false);
                    });
            }
            return null;
        };

        var hasRecordings = function () {
            return recordingsApi.hasRecordings();
        };

        var recordingOptions = {
            onDeleteRecordingClick: onDeleteRecordingClick,
            fetchSharedLink: fetchSharedLink,
            createSharedLink: createSharedLink,
            hasRecordings: hasRecordings,
            transcriptsUrl: self.transcriptsUrl
        };

        self.reactOptions = ko.computed(function () {
            return {
                component: MeetingHistory.default,
                props: {
                    meetings: {sessions: self.visibleMeetings()},
                    doShowMore: self.moreMeetingsToShow(),
                    locale: i18n.lng(),
                    is24Hours: self.useAmPm() === 'false',
                    viewReport: viewReport,
                    onCloudRecordingAction: onCloudRecordingAction,
                    showMore: showMoreMeetingsLinkClick,
                    hasOffset: self.g2mmSchedulingTest() === 'variation-a',
                    recordingOptions: recordingOptions,
                    userSettings: self.userSettings(),
                    meetingDiagnosticsBaseUrl: self.meetingDiagnosticsBaseUrl
                }
            };
        });

        // Private Methods
        function getToday() {
            var today = new Date();
            return new Date(today.getFullYear(), today.getMonth(), today.getDate());
        }

        // Subscribers

        // When to or from date picker change, check if
        // new meetings need to be fetched

        self.fromDate.subscribe(function () {
            if (moment(self.fromDate()).isAfter(self.toDate())) {
                self.toDate(self.fromDate());
            }

            self.datePickerUpdated();
        });

        self.toDate.subscribe(function () {
            if (moment(self.toDate()).isBefore(self.fromDate())) {
                self.fromDate(self.toDate());
            }

            self.datePickerUpdated();
        });

        // Public methods

        self.cleanDate = function (date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        };

        /*
         * Wrapper to get next batch of meetings
         *
         * @returns promise
         */
        self.getNextMeetingsBatch = function () {
            var request = {
                size: NUMBER_OF_MEETINGS_TO_RETURN,
                page: nextMeetingPageNumber
            };
            return self.getMeetings(request);
        };

        /*
         * Wrapper to get meetings for specified from and to dates
         *
         * @param from epoch time string
         * @param to epoch time string
         * @returns promise
         */
        self.getMeetingsForDateRange = function (from, to) {
            var request = {
                from: from,
                to: to
            };
            return self.getMeetings(request);
        };

        /*
         * General wrapper to make a api call to get meetings
         *
         * @param request
         * @returns {*} - promise
         */
        self.getMeetings = function (request) {
            if (!request) {
                throw new Error('Request body is required');
            }

            // Ensure meetings are in descending order
            request.order = 'desc';

            return meetingsApi.historyForOrganizerFormatted(request)
                .fail(function () {
                    // TODO Redirect to homepage
                });
        };

        /*
         * Accepts array of meetings, and appends them one by one to
         * the list of visible meetings
         */
        self.appendMeetings = function (meetingsToAppend) {
            // Array of Meetings to append is a required parameter
            if (!meetingsToAppend) {
                throw new Error('Tried to show meetings that have not been pre-loaded yet');
            }
            var visibleMeetings = self.visibleMeetings();

            _.forEach(meetingsToAppend, function (meeting) {
                // Make sure meeting is not already in the visible array
                if (_.indexOf(visibleMeetings, meeting) > -1) {
                    throw new Error('Meeting is already listed');
                }

                self.visibleMeetings.push(meeting);
            });
        };

        /*
         * Update datepicker to reflect date range changes, after lazy loaded
         * meetings have been added.
         */
        self.updateDatepickerToVisibleMeetingsRange = function () {
            var visibleMeetings = self.visibleMeetings();
            var lastMeeting = _.last(visibleMeetings);
            if (lastMeeting) {
                var fromTime = moment(lastMeeting.startTime).toDate();
                var toTime = getToday(); // Defaults to today
                self.fromDate(fromTime);
                self.toDate(toTime);
            }
        };

        /*
         * Checks if there are more meetings to be loaded.
         *
         * If not, hides the "show more" meetings link
         * if yes, gets the next meeting batch
         *
         * @returns {*}
         */
        self.checkForMoreMeetingsToLoad = function (meetings) {
            if (!meetings.next) { // No more meetings to show
                self.moreMeetingsToShow(false);
                self.nextMeetingBatch(null);
            } else { // More meetings to show
                return self.getNextMeetingsBatch()
                    .then(function (nextMeetings) {
                        self.nextMeetingBatch(nextMeetings);
                        nextMeetingPageNumber++;
                        self.moreMeetingsToShow(true);
                    });
            }
            return undefined;
        };

        /*
         * Displays lazy loaded meetings, updates datepicker, and
         * checks if more meetings need to be lazy loaded.
         */
        self.showMoreMeetings = function () {
            self.appendMeetings(self.nextMeetingBatch().sessions);
            self.updateDatepickerToVisibleMeetingsRange();
            return self.checkForMoreMeetingsToLoad(self.nextMeetingBatch());
        };

        /*
         * Check if user changed date range for meetings history.
         * If so, get new meeting list
         * If not, do nothing.
         *
         * Triggered by subscribing to datepicker observables
         *
         * @returns {*} promise
         */
        self.datePickerUpdated = function () {
            if (!self.fromDate() || !self.toDate()) {
                return;
            }

            var visibleMeetings = self.visibleMeetings();
            var currentFromMeeting;
            var currentFromTime;
            var currentToTime;

            if (visibleMeetings.length > 0) {
                currentFromMeeting = _.last(self.visibleMeetings());

                currentFromTime = moment(currentFromMeeting.startTime).valueOf();
                currentToTime = moment(getToday()).valueOf();
            } else {
                currentFromTime = 0;
                currentToTime = 0;
            }

            var newFromTime = moment(self.fromDate()).valueOf();
            var newToTime = moment(self.toDate()).valueOf();

            if (newFromTime && newToTime) { // Make sure both from and to dates has been selected
                if (currentFromTime !== newFromTime || currentToTime !== newToTime) { // If date ranges have changed
                    tagmanager.gaEvent({
                        category: 'Meeting History',
                        action: 'Datepicker Updated'
                    });
                    newFromTime = self.cleanDate(moment(newFromTime).toDate()).getTime();
                    newToTime = newToTime + 24 * 60 * 60 * 1000 - 1; // Get meetings up to the last minute of that day
                    /* eslint-disable consistent-return */

                    self.showLoadingIndicator(true);
                    return self.getMeetingsForDateRange(newFromTime, newToTime)
                        .then(function (meetings) {
                            self.moreMeetingsToShow(false);
                            self.visibleMeetings([]);
                            self.appendMeetings(meetings.sessions);
                            self.showLoadingIndicator(false);
                        })
                        .fail(function () {
                            self.showLoadingIndicator(false);
                        });
                    /* eslint-enable */
                }
            }
        };

        self.activate = function () {
            return $.when(
                self.getNextMeetingsBatch(),
                multivariateTesting.checkVariation('g2mmSchedulingTest'),
                // when me() (and other unfiltered ajax calls) is used inside a when call we need to filter out the extra parameters
                // otherwise the next .then() function receives an array [me, 'success', respose] instead of the me data
                userApi.me().then(function (me) { return me }),
                userApi.settings().then(function (userSettings) { return userSettings })
            )
            .then(function (meetings, variation, me, userSettings) {
                self.me(me);
                self.g2mmSchedulingTest(variation);
                self.userSettings(userSettings);
                nextMeetingPageNumber++;
                self.nextMeetingBatch(meetings);
                if (meetings.sessions.length > 0) {
                    self.hasMeetingsHistory = true;
                }
                return self.showMoreMeetings();
            });
        };
    };
});

